import {useContext} from "react";
import {ThemeCtx} from "../../../App";
import AuthModal from "./Modal";

export default function AuthModalConfig(props) {
    const { visible, setVisible } =props;

    const { theme } = useContext(ThemeCtx);

    const styleConfig = {
        buttonBackground: '#5F9CDA'
    }

    return(
        <AuthModal theme={theme} style={styleConfig} setVisible={setVisible} visible={visible}/>
    )
}
